module.exports = __webpack_public_path__ + "img/category_cover_Religion.02250fa.webp";